import { render, staticRenderFns } from "./route-shell.vue?vue&type=template&id=1531779a"
import script from "./route-shell.vue?vue&type=script&lang=ts"
export * from "./route-shell.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports